exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#secret-div[data-v-4308c05f]{border-style:solid;border-width:1px;box-shadow:1px 1px 10px 2px;color:#ccc;border-radius:10px;padding:10px;margin-left:25%;margin-top:10%;margin-bottom:10%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4308c05f","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/secret.vue
// module id = 861
// module chunks = 0